// @todo both Chrome and Firefox have a `resize` event for when the videoWidth
// or videoHeight properties change. We should investigate if this is also
// possible in Safari/ Edge. I'm not sure if the plugin supports it, but we
// should be able to add that. If that is the case, we could get rid of this
// code and the polling behavior

module.exports = function videoContentResizesMixinFactory({
  requestAnimationFrame = global.requestAnimationFrame,
} = {}) {
  return ({ element, onSizeChange, whenTimeIncrements }) => {
    let width = element.videoWidth;
    let height = element.videoHeight;
    let stopped = true;

    function checkSizeLoop() {
      if (stopped) {
        return;
      }

      if (width !== element.videoWidth || height !== element.videoHeight) {
        onSizeChange(
          { width, height },
          { width: element.videoWidth, height: element.videoHeight }
        );
        width = element.videoWidth;
        height = element.videoHeight;
      }
      whenTimeIncrements(() => requestAnimationFrame(checkSizeLoop));
    }

    return {
      start() {
        stopped = false;
        checkSizeLoop();
      },
      stop() {
        stopped = true;
      },
    };
  };
};



// WEBPACK FOOTER //
// ./src/js/helpers/pollForVideoResize.js